var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":"","elevation":"0"}},[_c('v-icon',{on:{"click":_vm.changeValue}},[_vm._v(_vm._s(_vm.localValue ? 'mdi-star' : 'mdi-star-outline'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }